import { useEffect, useState } from 'react'

// Components
import PageWrapper from 'components/PageWrapper'

// Api
import OTPValidation from 'components/OTPValidation'
import { getUrlSensitiveData } from 'api/credit-card'

// context + store
import { useCardIframeUrl, useDataToggleStore } from 'store'

import { trackEvent } from 'analytics/trackFunctions'
import { useNavigate, useParams } from 'react-router-dom'

const CardDataOTP = () => {
  const [otpInput, setOtpInput] = useState(new Array(6).fill(''))
  const [isRequesting, setIsRequesting] = useState(false)
  const {
    updatePhysicalCardUrl,
    updateVirtualCardUrl,
    updateUuid,
    currentUuid
  } = useCardIframeUrl()
  const { updateIsHidden } = useDataToggleStore()

  const { type } = useParams() as { type: 'VIRTUAL' | 'PHYSICAL' }

  const [inputStatus, setInputStatus] = useState('waiting')

  const navigate = useNavigate()

  const getUrl = (code) => {
    setIsRequesting(true)
    getUrlSensitiveData({ uuid: currentUuid, code })
      .then((res) => {
        const setter =
          type === 'VIRTUAL' ? updateVirtualCardUrl : updatePhysicalCardUrl
        updateUuid(null)
        setter(res)
        updateIsHidden({ state: false, type })
        navigate('/mis-tarjetas')
      })
      .catch(() => {
        setInputStatus('error')
      })
      .finally(() => {
        setIsRequesting(false)
      })
  }

  const handleConfirm = () => {
    getUrl(otpInput.join(''))
  }

  useEffect(() => {
    trackEvent({
      eventName: 'bille_tarjeta_otp'
    })
  }, [])

  return (
    <PageWrapper noTabBar title='Visualizar tarjeta'>
      <section className='sm:max-w-564 flex flex-col items-center sm:mt-0 mx-auto'>
        <OTPValidation
          inputValue={otpInput}
          setInputValue={setOtpInput}
          confirmAction={handleConfirm}
          inputStatus={inputStatus}
          isRequesting={isRequesting}
        />
      </section>
    </PageWrapper>
  )
}

export default CardDataOTP
